// @ts-nocheck
import React from 'react';
import Intelligence from './intelligence';
import { isIntelligenceRead, isReportRead } from 'models/user/selector';
const intelligenceRoutes = [
	{
		path: '/intelligence',
		key: 'key',
		componentId: 'intelligence',
		component: () => <Intelligence />,
		routes: [],
		importReducer: () => [],
		importSagas: () => [],
		title: 'Intelligence',
		isEnabled: (state) => {
			return isIntelligenceRead(state) || isReportRead(state);
		},
		headerName: 'Intelligence',
	},
];

export default intelligenceRoutes;
